(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // console.log('sticky header');
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      // console.log('setting --header-height', performance.now(), `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bp-multicolumn-count-up')) {
  customElements.define('bp-multicolumn-count-up', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const visual = this.querySelector('[data-count-up-text]');
      if (!visual || this.motion.matches || !('IntersectionObserver' in window)) return;
      this.parts = [];
      const walker = document.createTreeWalker(visual, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        const node = walker.currentNode;
        const original = node.nodeValue;
        const matches = [...original.matchAll(/(?:\d{1,3}(?:,\d{3})+|\d+)(?:\.\d+)?/g)];
        const tokens = matches.map((match) => {
          const raw = match[0];
          const decimals = (raw.split('.')[1] || '').length;
          return { raw, index: match.index, target: Number(raw.replaceAll(',', '')), decimals };
        });
        if (tokens.length && tokens.every((token) => Number.isFinite(token.target) && token.target <= Number.MAX_SAFE_INTEGER && token.decimals <= 6)) {
          this.parts.push({ node, original, tokens });
        }
      }
      if (!this.parts.length) return;
      this.onMotionChange = () => { if (this.motion.matches) this.finish(); };
      this.motion.addEventListener('change', this.onMotionChange);
      this.paint(0);
      this.observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.35)) {
          this.observer.disconnect();
          this.frame = requestAnimationFrame((time) => this.tick(time));
        }
      }, { threshold: 0.35 });
      this.observer.observe(this.querySelector('h3'));
    }

    paint(progress) {
      for (const part of this.parts) {
        let cursor = 0;
        let output = '';
        for (const token of part.tokens) {
          let number = (token.target * progress).toFixed(token.decimals);
          let [integer, fraction] = number.split('.');
          if (token.raw.includes(',')) integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          const rawInteger = token.raw.split('.')[0];
          if (!token.raw.includes(',') && /^0\d/.test(rawInteger)) integer = integer.padStart(rawInteger.length, '0');
          number = fraction === undefined ? integer : `${integer}.${fraction}`;
          output += part.original.slice(cursor, token.index) + number;
          cursor = token.index + token.raw.length;
        }
        part.node.nodeValue = output + part.original.slice(cursor);
      }
    }

    tick(time) {
      if (!this.isConnected) return;
      if (this.startedAt === undefined) this.startedAt = time;
      const progress = Math.min((time - this.startedAt) / 1600, 1);
      this.paint(1 - Math.pow(1 - progress, 3));
      if (progress < 1) this.frame = requestAnimationFrame((next) => this.tick(next));
      else this.finish();
    }

    finish() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      for (const part of this.parts || []) part.node.nodeValue = part.original;
      if (this.onMotionChange) this.motion.removeEventListener('change', this.onMotionChange);
    }

    disconnectedCallback() {
      this.finish();
      this.initialized = false;
      this.startedAt = undefined;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
